import { auth } from '../firebase.config';

// Proves to a Cloud Function who is calling. Functions that change accounts
// or teams check this token instead of trusting what the request body says.
const authHeaders = async () => {
  const user = auth.currentUser;
  return user ? { Authorization: `Bearer ${await user.getIdToken()}` } : {};
};

export default authHeaders;
